<tp-modal dialogTitle="Restore snapshot" [isBusy]="isSubmitting$ | async">
  <div class="tp-modal-content">
    <p>Would you like to restore the snapshot taken at {{ snapshotTimeString }}?</p>
    <tp-form [formGroup]="form" [isSubmitting$]="isSubmitting$" (doSubmit)="restoreCluster()">
      <tp-form-toggle-group [form]="form" field="restoreType" [options]="restoreOptions"/>
      @switch (form.value.restoreType) {
        @case("clone") {
          <p>
            This option will restore the snapshot to a new cluster with the same specs as this one, in the same provider and region.
          </p>
          <p>
            The new cluster can be queried using the same credentials that were active on this cluster at the time of the snapshot.
          </p>
          @if (price$ | async; as price) {
            @if (price.running.thousandthCentsPerHour != 0) {
              <div class="info-block">
                <i class="fa-solid fa-circle-info"></i>
                <p>
                  The new cluster will cost <strong>{{ runningPriceString(price) }}</strong> while running.
                </p>
              </div>
            }
          } @else {
            <tp-spinner/>
          }
        }
        @case ("current") {
          <div class="admonitionblock attention">
            <p>
              This option will delete the existing data on the cluster to replace it with the snapshot contents.
            </p>
            <p>
              The cluster will be temporarily inaccessible while it restarts with the new data.
            </p>
          </div>
        }
      }
      <tp-form-actions
        [isSubmitting]="isSubmitting$ | async" buttonIdPrefix="restore" [cancellable]="true"
        submitText="Restore" (cancel)="close()"
      />
    </tp-form>
  </div>
</tp-modal>
